import clsx from 'clsx'

export type SwitchProps = {
  checked: boolean
  onChange?: (value: boolean) => void
  disabled?: boolean
  /** Accessible label (required when there is no visible text label next to the switch). */
  label?: string
  className?: string
}

// Reusable toggle (role=switch) themed via CSS vars.
export const Switch = ({ checked, onChange, disabled, label, className }: SwitchProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange?.(!checked)}
    className={clsx(
      'tw-inline-flex tw-h-6 tw-w-11 tw-shrink-0 tw-items-center tw-rounded-full tw-transition-colors tw-duration-200',
      disabled ? 'tw-cursor-not-allowed tw-opacity-60' : 'tw-cursor-pointer',
      className,
    )}
    style={{
      backgroundColor: checked ? 'var(--primary-500)' : 'var(--input-bg)',
      border: '1px solid var(--page-border)',
    }}
  >
    <span
      className={clsx(
        'tw-h-5 tw-w-5 tw-rounded-full tw-bg-white tw-shadow tw-transition-transform tw-duration-200',
        checked ? 'tw-translate-x-[22px]' : 'tw-translate-x-[1px]',
      )}
    />
  </button>
)
